import {
  ddbDiagramIsValid,
  jsonDiagramIsValid,
} from "../../../utils/validateSchema";
import { Upload, Alert } from "antd";
import { DB, STATUS } from "../../../data/constants";
import {
  useAreas,
  useEnums,
  useNotes,
  useDiagram,
  useTypes,
} from "../../../hooks";
import { useTranslation } from "react-i18next";

export default function ImportDiagram({ setImportData, error, setError }) {
  const { areas } = useAreas();
  const { notes } = useNotes();
  const { tables, relationships, database } = useDiagram();
  const { types } = useTypes();
  const { enums } = useEnums();
  const { t } = useTranslation();

  const diagramIsEmpty = () => {
    return (
      tables.length === 0 &&
      relationships.length === 0 &&
      notes.length === 0 &&
      areas.length === 0 &&
      types.length === 0 &&
      enums.length === 0
    );
  };

  return (
    <div>
      <Upload
        action="#"
        beforeUpload={({ file, fileList }) => {
          const f = fileList[0].fileInstance;
          if (!f) {
            return;
          }
          const reader = new FileReader();
          reader.onload = async (e) => {
            let jsonObject = null;
            try {
              jsonObject = JSON.parse(e.target.result);
            } catch (error) {
              setError({
                type: STATUS.ERROR,
                message: "文件包含错误.",
              });
              return;
            }
            if (f.type === "application/json") {
              if (!jsonDiagramIsValid(jsonObject)) {
                setError({
                  type: STATUS.ERROR,
                  message:
                    "文件缺少必要的属性.",
                });
                return;
              }
            } else if (f.name.split(".").pop() === "ddb") {
              if (!ddbDiagramIsValid(jsonObject)) {
                setError({
                  type: STATUS.ERROR,
                  message:
                    "文件缺少必要的属性.",
                });
                return;
              }
            }

            if (!jsonObject.database) {
              jsonObject.database = DB.GENERIC;
            }

            if (jsonObject.database !== database) {
              setError({
                type: STATUS.ERROR,
                message:
                  "导入的图表和打开的图表不使用匹配的数据库.",
              });
              return;
            }

            let ok = true;
            jsonObject.relationships.forEach((rel) => {
              if (
                !jsonObject.tables[rel.startTableId] ||
                !jsonObject.tables[rel.endTableId]
              ) {
                setError({
                  type: STATUS.ERROR,
                  message: `关系 ${rel.name} 引用不存在的表.`,
                });
                ok = false;
                return;
              }

              if (
                !jsonObject.tables[rel.startTableId].fields[rel.startFieldId] ||
                !jsonObject.tables[rel.endTableId].fields[rel.endFieldId]
              ) {
                setError({
                  type: STATUS.ERROR,
                  message: `关系 ${rel.name} 引用不存在的字段.`,
                });
                ok = false;
                return;
              }
            });

            if (!ok) return;

            setImportData(jsonObject);
            if (diagramIsEmpty()) {
              setError({
                type: STATUS.OK,
                message: "一切正常，您现在可以导入。",
              });
            } else {
              setError({
                type: STATUS.WARNING,
                message:
                  "当前图表不是空的。导入新图表将覆盖当前更改。",
              });
            }
          };
          reader.readAsText(f);

          return {
            autoRemove: false,
            fileInstance: file.fileInstance,
            status: "success",
            shouldUpload: false,
          };
        }}
        draggable={true}
        dragMainText={t("drag_and_drop_files")}
        dragSubText={t("support_json_and_ddb")}
        accept="application/json,.ddb"
        onRemove={() =>
          setError({
            type: STATUS.NONE,
            message: "",
          })
        }
        onFileChange={() =>
          setError({
            type: STATUS.NONE,
            message: "",
          })
        }
        limit={1}
      />
      {error.type === STATUS.ERROR ? (
        <Alert
          type="error"
          message={error.message}
          style={{ marginTop: "16px" }}
        />
      ) : error.type === STATUS.OK ? (
        <Alert
          type="info"
          message={error.message}
          style={{ marginTop: "16px" }}
        />
      ) : (
        error.type === STATUS.WARNING && (
          <Alert
            type="warning"
            message={error.message}
            style={{ marginTop: "16px" }}
          />
        )
      )}
    </div>
  );
}
